import type { App } from "vue";

import insetPermission from "./permission";

export default function (app: App) {
  insetPermission(app);
}
